import React, { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';
import cls from './EllipsisAnimated.module.css';

export const EllipsisAnimated = forwardRef<SVGSVGElement, Partial<QIconProps>>(
  (props, ref) => {
    return (
      <Icon viewBox="0 0 24 24" color="currentColor" {...props} ref={ref}>
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g fill="currentColor">
            <circle className={`${cls.dot} ${cls.dot1}`} cx="4" cy="12" r="2" />
            <circle
              className={`${cls.dot} ${cls.dot2}`}
              cx="12"
              cy="12"
              r="2"
            />
            <circle
              className={`${cls.dot} ${cls.dot3}`}
              cx="20"
              cy="12"
              r="2"
            />
          </g>
        </svg>
      </Icon>
    );
  },
);

EllipsisAnimated.displayName = 'EllipsisAnimated';
